// src/components/sourcex/useSiteAdmin.js
//
// Is the signed-in person an admin of the active site (owner, tenant admin or
// site admin)? The same rule StudyDetailsPage uses, for SourceX pages that let
// only an admin override a lock (e.g. rebuilding built source documents).

import { useTenant } from "../../context/TenantContext";
import { effectiveRole } from "../../services/membershipService";

export const useSiteAdmin = () => {
  const { access, tenantId, siteId } = useTenant();
  const role = effectiveRole(access, tenantId, siteId);
  return role === "admin" || role === "owner" || Boolean(access?.isOwner);
};

export default useSiteAdmin;
